import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import { INDIAN_STATES } from '../constants/indianStates';

export default function RegisterCentre() {
  const [searchParams] = useSearchParams();
  const refCode        = searchParams.get('referralCode') || '';
  const verifyError    = searchParams.get('verifyError')   || '';

  const [form,       setForm]       = useState({ tenantName: '', whatsappNumber: '', city: '', state: '', adminEmail: '' });
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg,   setErrorMsg]   = useState('');
  const [sent,       setSent]       = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setErrorMsg('');
    if (!form.tenantName.trim())     { setErrorMsg('Centre name is required.');      return; }
    if (!form.whatsappNumber.trim()) { setErrorMsg('WhatsApp number is required.');   return; }
    if (!form.city.trim())           { setErrorMsg('City is required.');              return; }
    if (!form.state)                 { setErrorMsg('Please select your state.');      return; }
    if (!form.adminEmail.trim())     { setErrorMsg('Admin email is required.');       return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.adminEmail)) {
      setErrorMsg('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/centre/register', {
        ...form,
        ...(refCode && { referralCode: refCode }),
      });
      setSent(true);
    } catch (err) {
      setErrorMsg(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <div style={S.page}>
        <div style={S.card}>
          <h1 style={S.title}>Check your inbox</h1>
          <p style={{ fontSize: 15, color: '#374151', lineHeight: 1.7, margin: '12px 0 0' }}>
            We've sent a verification link to <strong>{form.adminEmail}</strong>.
            Click the link in the email to complete your registration.
          </p>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 16 }}>
            The link expires in 24 hours. Check your spam folder if you don't see it.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <div style={S.card}>
        <h1 style={S.title}>Register Your Healing Centre</h1>
        <p style={S.sub}>Join LifeChiAI and start managing your centre digitally.</p>
        {verifyError === 'expired' && (
          <div style={S.errorBanner}>
            This verification link has expired. Please register again to receive a new link.
          </div>
        )}
        {verifyError === 'invalid' && (
          <div style={S.errorBanner}>
            This verification link is invalid or has already been used. Please register again.
          </div>
        )}
        {refCode && (
          <div style={S.referralBanner}>
            You were invited to join LifeChiAI. Your referral will be recorded on approval.
          </div>
        )}
        <form onSubmit={handleSubmit} noValidate>
          {errorMsg && <div style={S.errorBanner}>{errorMsg}</div>}

          <label style={S.label}>Centre Name *</label>
          <input
            name="tenantName"
            value={form.tenantName}
            onChange={handleChange}
            style={S.input}
            autoComplete="organization"
          />

          <label style={S.label}>WhatsApp Number * (with country code)</label>
          <input
            name="whatsappNumber"
            value={form.whatsappNumber}
            onChange={handleChange}
            style={S.input}
            placeholder="+919876543210"
            type="tel"
          />

          <label style={S.label}>City *</label>
          <input
            name="city"
            value={form.city}
            onChange={handleChange}
            style={S.input}
            autoComplete="address-level2"
          />

          <label style={S.label}>State *</label>
          <select name="state" value={form.state} onChange={handleChange} style={S.input} required>
            <option value="">Select state</option>
            {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>

          <label style={S.label}>Admin Email * (for verification)</label>
          <input
            name="adminEmail"
            value={form.adminEmail}
            onChange={handleChange}
            style={S.input}
            type="email"
            autoComplete="email"
            placeholder="admin@yourcentre.com"
          />

          <button type="submit" style={S.btn} disabled={submitting}>
            {submitting ? 'Submitting…' : 'Register Centre'}
          </button>
        </form>
      </div>
    </div>
  );
}

const S = {
  page:          { minHeight: '100vh', backgroundColor: '#f0faf6', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '40px 16px' },
  card:          { backgroundColor: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 440, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
  title:         { fontSize: 22, fontWeight: 800, color: '#1a3d2b', marginBottom: 8, fontFamily: "'Raleway', sans-serif" },
  sub:           { fontSize: 14, color: '#6b7280', marginBottom: 20 },
  referralBanner:{ backgroundColor: '#f0faf6', border: '1px solid #a7d7c5', color: '#1a3d2b', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  label:         { display: 'block', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6, marginTop: 14 },
  input:         { width: '100%', padding: '12px 14px', fontSize: 16, border: '1.5px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box', outline: 'none' },
  btn:           { marginTop: 20, width: '100%', padding: '14px 0', backgroundColor: '#1a6b5a', color: '#fff', fontSize: 16, fontWeight: 700, border: 'none', borderRadius: 10, cursor: 'pointer' },
  errorBanner:   { backgroundColor: '#fef2f2', border: '1px solid #fca5a5', color: '#dc2626', borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 12 },
};
